import React from 'react';

interface IProps {
  props?: React.SVGProps<SVGSVGElement> & { circleRadius?: number }
}

const DotsIcon = ({ props }: IProps) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="7" cy="12.5" r={props?.circleRadius || '2'} fill="#7C828D" />
    <circle cx="12" cy="12.5" r={props?.circleRadius || '2'} fill="#7C828D" />
    <circle cx="17" cy="12.5" r={props?.circleRadius || '2'} fill="#7C828D" />
  </svg>
);

export default DotsIcon;
